<template>
    <van-overlay :show="show" @click="close" style="z-index: 1000;text-align: center">
    <Loading v-if="requested" />
        <div class="wrapper" @click.stop>
            <div class="block">
                <div class="header">
                    <a class="close" @click="close">
                        <van-icon name="cross" />
                    </a>
                    
                    <div class="title">
                        <span>Payment Method</span>
                    </div>
                </div>
                
                <div class="content">
                    <div :key="index" v-for="(item, index) in payMethod.available">
                        <div @click="submit(item)">
                            <div class="delivery">
                                <div style="display: flex; align-items: center; padding: 0 16px; margin: 6px 0;">
                                    <div>
                                        <icon v-if="item.includes('Card')" color="#ee2d24" size="20px" name="credit-card"/>
                                        <icon v-if="item.includes('Banking')" color="#ee2d24" size="20px" name="money-check-alt"/>
                                        <icon v-if="item.includes('E-Wallet')" color="#ee2d24" size="20px" name="wallet"/>
                                    </div>
                                    <div style="padding-left: 16px; text-align: left;font-size: 14px;">{{item}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </van-overlay>
</template>
<script>
import Loading from '@/components/common/Loading.vue'
export default {
  components: {Loading},
    props: {
        confirm: {
            type: Function
        },
        cancel: {
            type: Function
        },
        store: {
            type: Object
        },
        payMethod: {
            type: Object
        },
    },
    data() {
        return {
            requested: false,
            show: true,
            width: '250',
            color: '#fff',
            textSize: '14px',
            expand: false
        }
    },
    created() {
      console.log('Payment Method for the store',this.payMethod.available)
    },
    methods: {
        close() {
            this.show = false;
            this.cancel();
        },
        submit(item) {
            if (item.includes('Card')){
                this.payMethod.choosedPayment = 'CC';
                this.payMethod.choosedChannel = 'GOBIZ';
            } else if (item.includes('E-Wallet')){
                this.payMethod.choosedPayment = 'EW';
                this.payMethod.choosedChannel = 'RM';
            } else if (item.includes('Banking')) {
                this.payMethod.choosedPayment = 'OB';
                this.payMethod.choosedChannel = 'REVPAY';
            }
            console.log('Choosed payment',this.payMethod.choosedPayment, ', Choosed channel',this.payMethod.choosedChannel)
            this.confirm();
        },
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: fit-content;
}

.block {
    background-color: #f2f2f2;
    border-radius: 6px;
    min-width: 250px;
    max-width: 330px;
    max-height: 500px;
    display: flex;
    flex-direction: column;
}

.flex {
    align-items: center;
    padding: 6px;
}

.icon-text {
    padding-left: 6px;
}

.dot {
    line-height: 6px;
    align-items: center;
    display: flex;
    justify-content: center;
    color: #ee2d24;
}

.title {
    text-align: center;
    background-color: #ee2d24;
    padding: 16px 16px 10px 55px;
    color: #fff;
    font-weight: 700;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.content {
    padding: 6px;
    display: contents;
}

.btn-action {
    display: flex;
    flex: 1;
    cursor: pointer;
}

.btn-confirm {
    height: 48px;
    background-color: #ee2d24;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-right-radius: 6px;
}

.btn-cancel {
    height: 48px;
    background-color: #fff;
    color: #ee2d24;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 6px;
}

.delivery {
    margin: 6px; 
    padding: 6px 0; 
    background-color: #fff;
    border-radius: 6px;
}
.delivery:active {
    background-color: #DCDCDC;
}

.transport {
    animation: van-fade-in 1s;
    margin: 6px;
    margin-left: 50px;
    padding: 6px 0;
    //background-color: rgb(201, 201, 201);
    border-radius: 6px;
    width: fit-content;
}

.info {
    text-align: center;
    font-size: 18px;
}

.close {
    float: right;
    padding: 16px;
    color: #fff;
}

.disable {
    color: #999;
}
</style>